import {
  SelfServiceCampaignAction,
  SelfServiceCampaignResponse,
} from '@provider-portal/common/api/gen/CampaignDeliveryProvider';

export const getPromotionState = (
  promotion: SelfServiceCampaignResponse | null,
): 'ended' | 'scheduled' | 'active' => {
  if (!promotion) {
    return 'ended';
  }
  if (promotion.action === SelfServiceCampaignAction.REMOVED) {
    return 'ended';
  }
  const now = Math.floor(Date.now() / 1000);
  if (now < promotion.start_timestamp) {
    return 'scheduled';
  }
  if (now > promotion.end_timestamp) {
    return 'ended';
  }
  return 'active';
};
